import React, { useState } from 'react';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { D as DataListLayoutContext } from './DataListLayoutContext-CRuQjlBl.js';
import { D as DataListItem } from './DataListItem-DJ3vPIxZ.js';

function DataListItems({ size = "xs", }) {
    const { data, layouts } = useDataListContext();
    const [hasInLayoutActions, setHasInLayoutActions] = useState(false);
    const layout = layouts[size];
    if (!layout)
        return null;
    return (React.createElement(DataListLayoutContext.Provider, { value: {
            isInLayoutProvider: true,
            hasInLayoutActions,
            setHasInLayoutActions,
        } }, data.map((child, i) => (React.createElement(DataListItem, { key: data[i].id, index: i, item: child, layout: layout })))));
}

export { DataListItems as D };
